<template>
  <validation-observer
    ref="syllabusSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="syllabusSaveModal"
      body-class="position-static"
      size="lg"
      centered
      :title="isCreated ? 'Thêm đề cương học phần' : 'Cập nhật đề cương học phần'"
      no-close-on-backdrop
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col cols="6">
            <b-form-group label-for="trainingSystemId">
              <template v-slot:label>
                {{ trainingSystemLabel }} <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                :name="trainingSystemLabel"
                rules="required"
              >
                <v-select
                  v-model="targetSyllabus.trainingSystemId"
                  :disabled="!isCreated"
                  :options="trainingSystems"
                  :reduce="option => option.value"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  @input="onTrainingSystemsChange"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="courseId">
              <template v-slot:label>
                Khóa học <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Khóa học"
                rules="required"
              >
                <v-select
                  v-model="targetSyllabus.courseId"
                  :disabled="!isCreated"
                  :options="courses"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-form-group label-for="departmentId">
              <template v-slot:label>
                Khoa/Phòng/Bộ môn <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Khoa/Phòng/Bộ môn"
                rules="required"
              >
                <v-select
                  v-model="targetSyllabus.departmentId"
                  :disabled="!isCreated"
                  :options="departments"
                  :reduce="option => option.value"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  @input="onDepartmentChange"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group label-for="subjectId">
              <template v-slot:label>
                Học phần <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Ngành học"
                rules="required"
              >
                <v-select
                  v-model="targetSyllabus.subjectId"
                  :disabled="!isCreated"
                  :options="subjects"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group label-for="code">
          <template v-slot:label>
            Mã đề cương <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            name="Mã đề cương"
            rules="required"
          >
            <b-form-input
              id="code"
              v-model="targetSyllabus.code"
              name="code"
              placeholder="Nhập mã đề cương"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group label-for="name">
          <template v-slot:label>
            Tên đề cương <span class="text-danger">*</span>
          </template>
          <validation-provider
            #default="{ errors }"
            :name="'Tên đề cương'"
            rules="required"
          >
            <b-form-input
              id="name"
              v-model="targetSyllabus.name"
              name="name"
              placeholder="Nhập tên đề cương"
              :state="getElementState(errors)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <b-form-group label-for="status">
              <template v-slot:label>
                Trạng thái <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Trạng thái"
                rules="required"
              >
                <v-select
                  v-model="targetSyllabus.status"
                  :options="statusOptions"
                  :class="{ 'is-invalid': errors.length > 0 }"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('syllabusSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        no-wrap
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BOverlay,
  BRow,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { getUser } from '@/auth/utils'
import apiCommon from '@/views/apiCommon'
import { STATUSES } from '@/const/status'
import { OrganizationCode } from '@/const/code'
import api from './api'

export default {
  name: 'SyllabusSave',
  components: {
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    syllabus: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      targetSyllabus: {
        name: null,
        code: null,
        status: 1,
        courseId: null,
        subjectId: null,
      },
      trainingSystems: [],
      courses: [],
      departments: [],
      subjects: [],
      required,
      statuses: STATUSES,
    }
  },
  computed: {
    statusOptions() {
      return this.statuses.map(item => ({ value: item.value, label: item.label }))
    },
    isCreated() {
      return !this.syllabus
    },
    trainingSystemLabel() {
      return getUser().orgCode === OrganizationCode.HLUV ? 'Hệ đào tạo' : 'Hình thức đào tạo'
    },
  },
  methods: {
    async onTrainingSystemsChange(event) {
      this.targetSyllabus.courseId = null
      const { courses } = await apiCommon.getCourses({ trainingSystemId: event })
      this.courses = courses
    },
    async onDepartmentChange(event) {
      this.targetSyllabus.subjectId = null
      this.subjects = await apiCommon.getSubjects({ departmentId: event })
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      this.isLoading = true
      if (this.syllabus) this.targetSyllabus = { ...this.syllabus }

      const [trainingSystems, departments] = await Promise.all([
        apiCommon.getTrainingSystems(),
        apiCommon.getDepartments(),
      ])
      this.trainingSystems = trainingSystems
      this.departments = departments
      if (!this.isCreated) {
        const [coursesRes, subjects] = await Promise.all([
          apiCommon.getCourses({ trainingSystemId: this.syllabus.trainingSystemId }),
          apiCommon.getSubjects({ departmentId: this.syllabus.departmentId }),
        ])
        this.courses = [...coursesRes.courses]
        this.subjects = subjects
      }
      this.isLoading = false
    },
    onHide() {
      this.$refs
        .syllabusSaveFormRef
        .reset()
      this.targetSyllabus = {
        name: null,
        code: null,
        status: 1,
        courseId: null,
        subjectId: null,
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .syllabusSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await api.createSyllabus(this.targetSyllabus)
            : await api.updateSyllabus(this.targetSyllabus)
          if (response) {
            const {
              isSuccessful,
              message,
            } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('syllabusSaveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Lỗi khi lưu',
              text: `${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.is-invalid .vs__dropdown-toggle {
  border-color: #ea5455;
}
</style>
